import {
  SOLICITACAO_STATUS_DISPONIVEL,
  SOLICITACAO_STATUS_PENDENTE,
  SOLICITACAO_STATUS_PROCESSANDO,
} from '@/services/Relatorios/types';

export type SituacaoDaSolicitacao = 'pronto' | 'gerando' | 'falhou';

export const ROTULO_DA_SITUACAO: Record<SituacaoDaSolicitacao, string> = {
  pronto: 'Pronto',
  gerando: 'Gerando',
  falhou: 'Falhou',
};

// Sem Status_id (resposta de antes de o histórico trazê-lo) vale o caminho. Status fora de 1 a 4
// (5 cancelado, 6 sem dados) não volta a gerar: tratá-lo como "gerando" deixaria a tela
// consultando para sempre.
export function situacaoDaSolicitacao(
  statusId: number | null | undefined,
  caminho: string | null | undefined
): SituacaoDaSolicitacao {
  if (statusId === null || statusId === undefined) return caminho ? 'pronto' : 'falhou';
  if (statusId === SOLICITACAO_STATUS_PENDENTE || statusId === SOLICITACAO_STATUS_PROCESSANDO) {
    return 'gerando';
  }
  if (statusId === SOLICITACAO_STATUS_DISPONIVEL && caminho) return 'pronto';
  return 'falhou';
}

export function algumaGerando(
  solicitacoes: ReadonlyArray<{ Status_id: number; Caminho_Relatorio: string | null }>
): boolean {
  return solicitacoes.some(
    s => situacaoDaSolicitacao(s.Status_id, s.Caminho_Relatorio) === 'gerando'
  );
}
